import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './ContactButton.css';

const ContactButton: React.FC = () => {
  const [isScrolledFromTop, setIsScrolledFromTop] = useState(false);

  // Track scroll position to hide/show contact button
  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      setIsScrolledFromTop(scrollTop > 100); // Show button after scrolling 100px
    };

    // Set initial state
    handleScroll();

    // Add scroll listener
    window.addEventListener('scroll', handleScroll, { passive: true });

    // Cleanup
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <Link
      to="/kontakt"
      className={`contact-button ${isScrolledFromTop ? 'visible' : 'hidden'}`}
      title="Kontakt"
      aria-label="Zur Kontakt-Seite"
    >
      <span className="contact-at-symbol">@</span>
    </Link>
  );
};

export default ContactButton;
